// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5cjQ7","top":"styles_top__mTgXx","left":"styles_left__2qSwZ","description":"styles_description__2ziR3"};